<template>
  <el-dialog :title="$t('gridWorker.title')" :visible.sync="visible" width="30%" @close="closeDialog">
    <el-form ref="form" :model="formData" :rules="rules" label-width="120px">
      <el-row>
        <el-col :span="24">
          <el-form-item :label="$t('gridWorker.name')" prop="repairTypeName">
            <el-input v-model="formData.repairTypeName" :placeholder="$t('gridWorker.namePlaceholder')" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item :label="$t('gridWorker.phone')" prop="repairTypeName">
            <el-input v-model="formData.repairTypeName" :placeholder="$t('gridWorker.phonePlaceholder')" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item :label="$t('gridWorker.idNumber')" prop="idNumber">
            <el-input v-model="formData.idNumber" :placeholder="$t('gridWorker.idNumberPlaceholder')" />
          </el-form-item>
        </el-col>
      </el-row>
      
      
      <el-row>
        <el-col :span="24">
          <el-form-item :label="$t('gridWorker.remark')" prop="remark">
            <el-input v-model="formData.remark" type="textarea" :rows="3"
              :placeholder="$t('gridWorker.remarkPlaceholder')" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('gridWorker.cancel') }}</el-button>
      <el-button type="primary" @click="submitForm">{{ $t('gridWorker.submit') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveRepairSetting } from '@/api/work/repairSettingApi'

export default {
  name: 'AddGridWorker',
  data() {
    return {
      visible: false, 
      formData: {
        repairTypeName: '',
        repairWay: '200',
        repairSettingType: '200',
        remark: '',
        publicArea: 'F',
        payFeeFlag: 'F',
        returnVisitFlag: '003',
        isShow: 'Y',
        doTime: 24,
        warningTime: 30,
        notifyWay: 'WECHAT'
      },
      rules: {
        repairTypeName: [
          { required: true, message: this.$t('gridWorker.namePlaceholder'), trigger: 'blur' },
        ],
        repairSettingType: [
          { required: true, message: this.$t('gridWorker.settingTypeRequired'), trigger: 'change' }
        ],
        repairWay: [
          { required: true, message: this.$t('gridWorker.dispatchMethodRequired'), trigger: 'change' }
        ],
        publicArea: [
          { required: true, message: this.$t('gridWorker.publicAreaRequired'), trigger: 'change' }
        ],
        isShow: [
          { required: true, message: this.$t('gridWorker.ownerDisplayRequired'), trigger: 'change' }
        ],
        notifyWay: [
          { required: true, message: this.$t('gridWorker.notificationMethodRequired'), trigger: 'change' }
        ],  
        returnVisitFlag: [
          { required: true, message: this.$t('gridWorker.returnVisitRequired'), trigger: 'change' }
        ],
        doTime: [
          { required: true, message: this.$t('gridWorker.processingTimeRequired'), trigger: 'blur' },
          { type: 'number', min: 1, message: this.$t('gridWorker.processingTimeMin'), trigger: 'blur' }
        ],
        warningTime: [
          { required: true, message: this.$t('gridWorker.timeoutWarningRequired'), trigger: 'blur' },
          { type: 'number', min: 1, message: this.$t('gridWorker.timeoutWarningMin'), trigger: 'blur' }
        ],
        remark: [
          { max: 500, message: this.$t('gridWorker.remarkMaxLength'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.visible = true
    },

    closeDialog() {
      this.visible = false
      this.resetForm()
    },

    resetForm() {
      this.$refs.form.resetFields()
      this.formData = {
        repairTypeName: '',
        repairWay: '200',
        repairSettingType: '200',
        remark: '',
        publicArea: 'F',
        payFeeFlag: 'F',
        returnVisitFlag: '003',
        isShow: 'Y',
        doTime: 24,
        warningTime: 30,
        notifyWay: 'WECHAT'
      }
    },

    submitForm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            await saveRepairSetting(this.formData)
            this.$message.success(this.$t('common.operationSuccess'))
            this.$emit('success')
            this.closeDialog()
          } catch (error) {
            console.error('添加报修设置失败:', error)
            this.$message.error(this.$t('repairSetting.addFailed'))
          }
        }
      })
    }
  }
}
</script>